var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE1\x84\x80\xE1\x85\xB3\xE1\x86\xB7\xE1\x84\x8B\xE1\x85\xB2\xE1\x86\xBC\xE1\x84\x8B\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x8F\xE1\x85\xA9\xE1\x86\xAB_SVG_\xE1\x84\x8C\xE1\x85\xA5\xE1\x84\x8E\xE1\x85\xAE\xE1\x86\xA8\xE1\x84\x8B\xE1\x85\xB3\xE1\x86\xAB\xE1\x84\x92\xE1\x85\xA2\xE1\x86\xBC 1",
    clipPath: "url(#clip0_1736_10102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z",
    fill: "#005743"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.45532 6.51728C7.75599 7.1375 7.40332 8.01416 7.40332 9.12328C7.40332 10.7082 8.49465 11.5379 8.96021 11.8922C9.01265 11.9344 9.08643 11.9868 9.10576 12.0066L9.17243 12.0682C9.46132 12.3335 9.99865 12.8255 9.99865 13.4431C9.99865 14.5097 8.80288 15.7097 8.22088 16.0824H10.2531C11.0895 15.2017 11.5153 14.3153 11.5153 13.4431C11.5153 12.1615 10.5931 11.3137 10.1987 10.9519L10.1411 10.8984C10.0642 10.8268 9.97821 10.7613 9.87865 10.6855C9.37376 10.3015 8.91932 9.89239 8.91932 9.12328C8.91932 8.45972 9.09554 7.97972 9.45821 7.65483C9.82088 7.32994 10.6393 7.23661 11.3558 7.22839V5.72461C10.3684 5.74816 9.13688 5.91216 8.45532 6.51728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.8667 18.3117H12.3521V5.69279L13.1063 5.68945H13.1156C13.3625 5.68945 15.1823 5.72856 16.3098 6.85145C16.8603 7.39856 17.1514 8.12723 17.1514 8.95523C17.1572 9.39456 17.0347 10.0846 16.6292 10.6475C17.1063 11.1226 17.5969 11.8739 17.5969 12.9566C17.5969 14.8599 15.7878 16.0699 13.8654 16.2779L13.8667 18.3117ZM14.4267 10.8179C15.7549 10.1995 15.6358 8.97123 15.6358 8.97123V8.9619C15.6358 8.51345 15.5194 7.87301 14.5125 7.47634C14.3031 7.39576 14.087 7.33381 13.8667 7.29123V14.751C14.3985 14.6723 14.9 14.4901 15.2972 14.2255C15.656 13.9861 16.0836 13.5717 16.0836 12.9572C16.0865 12.7325 16.0438 12.5094 15.9581 12.3016C15.8724 12.0938 15.7454 11.9055 15.5849 11.7481C15.2509 11.4137 14.4267 10.8179 14.4267 10.8179Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1736_10102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaving);
export default __webpack_public_path__ + "static/media/saving.e38702d8e795d39ef80685b2852efa67.svg";
export { ForwardRef as ReactComponent };